// import store from "../redux/store";
// import dayjs from "dayjs";
// import utc from "dayjs/plugin/utc";
// import timezone from "dayjs/plugin/timezone";
// import { getLocalInfoStart } from "../redux/slices/setting/settingsSlice";

// dayjs.extend(utc);
// dayjs.extend(timezone);

// const timezoneMapping = {
//   1: "Asia/Kolkata",        // IST
//   2: "America/New_York",    // EST
//   3: "America/Los_Angeles", // PST
// };

// function ensureLocaleInfo() {
//   console.log("Called ensure")
//   const state = store.getState();
//   const { companyProfile } = state.settings;
//   const localeInfo = companyProfile?.localInfo;
//   if (!localeInfo || !localeInfo.timezone) {
//     const user = state.auth?.user;
//     if (user?.data?.organizationId?.uiid) {
//       store.dispatch(
//         getLocalInfoStart({
//           coll: "Organization",
//           fil: { uiid: { type: "NONE", value: user.data.organizationId.uiid } },
//           ret: "localeInfo",
//         })
//       );
//     }
//   }
//   if (!localeInfo || !localeInfo.timezone) {
//     localeInfo = {
//       timezone: "MACHINE",  // special key
//       timeFormat: 24,
//     };
//   }
//   console.log("localeInfo",localeInfo)
//   return localeInfo || {};
// }

// export function toUTC(inputDate) {
//   if (!inputDate) return null;

//   // const { companyProfile } = store.getState().settings;
//   // const localeInfo = companyProfile?.localInfo || {};
//   const localeInfo = ensureLocaleInfo();

//   // const orgTimeZone = timezoneMapping[localeInfo?.timezone] || "UTC";

//   // return dayjs.tz(inputDate, orgTimeZone).utc().toISOString();
//   let orgTimeZone;
//   if (localeInfo.timezone === "MACHINE") {
//     orgTimeZone = dayjs.tz.guess(); // machine timezone
//   } else {
//     orgTimeZone = timezoneMapping[localeInfo?.timezone] || "UTC";
//   }
// }

// export function fromUTC(inputDate) {
//   if (!inputDate) return "";

//   // const { companyProfile } = store.getState().settings;
//   // const localeInfo = companyProfile?.localInfo || {};
//   const localeInfo = ensureLocaleInfo();

//   // const orgTimeZone = timezoneMapping[localeInfo?.timezone] || "UTC";
//   // const timeFormat = localeInfo?.timeFormat || 24;
//   let orgTimeZone;
//   if (localeInfo.timezone === "MACHINE") {
//     orgTimeZone = dayjs.tz.guess(); // machine timezone
//   } else {
//     orgTimeZone = timezoneMapping[localeInfo?.timezone] || "UTC";
//   }

//   const formatString =
//     timeFormat === 1
//       ? "MMM DD, YYYY, hh:mm A"   // 12hr AM/PM
//       : "MMM DD, YYYY, HH:mm";    // 24hr

//   return dayjs.utc(inputDate).tz(orgTimeZone).format(formatString);
// }

import store from "../redux/store";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { getLocalInfoStart } from "../redux/slices/setting/settingsSlice";

dayjs.extend(utc);
dayjs.extend(timezone);

const timezoneMapping = {
  1: "Asia/Kolkata",        // IST
  2: "America/New_York",    // EST
  3: "America/Los_Angeles", // PST
};

// function ensureLocaleInfo() {
//   const state = store.getState();
//   const { companyProfile } = state.settings;
//   let localeInfo = companyProfile?.localInfo;

//   // If not found, trigger fetch
//   if (!localeInfo || !localeInfo.timezone) {
//     const user = state.auth?.user;
//     if (user?.data?.organizationId?.uiid) {
//       store.dispatch(
//         getLocalInfoStart({
//           coll: "Organization",
//           fil: { uiid: { type: "NONE", value: user.data.organizationId.uiid } },
//           ret: "localeInfo",
//         })
//       );
//     }
//   }

//   // Fallback to machine defaults
//   if (!localeInfo || !localeInfo.timezone) {
//     localeInfo = {
//       timezone: "MACHINE",  // special key
//       timeFormat: 24,
//     };
//   }

//   return localeInfo;
// }
function getEffectiveLocale() {
  const state = store.getState();
  const user = state.auth?.user?.data;

  if (!user) return null;

  const orgLocale = user.organizationId?.locale;
  const roleLocale = user.role?.locale;
  const userLocale = user.locale;

  const defaultType = orgLocale?.default;

  if (defaultType === 1) {
    return orgLocale;
  }

  if (defaultType === 2) {
    if (roleLocale) return roleLocale;
    return orgLocale;
  }

  if (defaultType === 3) {
    return (
      userLocale?.ats ||
      userLocale?.workforce ||
      userLocale?.benchsales ||
      orgLocale
    );
  }

  return orgLocale;
}

export function ensureLocaleInfo() {
  const state = store.getState();
  const user = state.auth?.user?.data;

  const locale = getEffectiveLocale();
 
  const orgLocale = user?.organizationId?.locale;

  return locale?.timezone ? locale : orgLocale;
}


export function convertToUTC(inputDate) {
  if (!inputDate) return null;

  const localeInfo = ensureLocaleInfo();

  // let orgTimeZone;
  // if (localeInfo.timezone === "MACHINE") {
  //   orgTimeZone = dayjs.tz.guess(); // machine timezone
  // } else {
  //   orgTimeZone = timezoneMapping[localeInfo?.timezone] || "UTC";
  // }

  // // Convert org local → UTC
  // return dayjs.tz(inputDate, orgTimeZone).utc().toISOString();
  const orgTimeZone =
    timezoneMapping[localeInfo?.timezone] || "Asia/Kolkata";

  return dayjs.tz(inputDate, orgTimeZone).utc().toISOString();
}
export function getZoneBasedOnLocaleInfo() {
  const localeInfo = ensureLocaleInfo();
  const orgTimeZone =
    timezoneMapping[localeInfo?.timezone] || "Asia/Kolkata";
  return orgTimeZone;
};

export function convertFromUTC(inputDate) {
  if (!inputDate) return "";

  const localeInfo = ensureLocaleInfo();

  // let orgTimeZone;
  // if (localeInfo.timezone === "MACHINE") {
  //   orgTimeZone = dayjs.tz.guess(); // machine timezone
  // } else {
  //   orgTimeZone = timezoneMapping[localeInfo?.timezone] || "UTC";
  // }
  const orgTimeZone =
    timezoneMapping[localeInfo?.timezone] || "Asia/Kolkata";
  const timeFormat = localeInfo?.timeFormat || 24;
  const formatString =
    timeFormat === 1
      ? "DD MMM, YYYY, hh:mm A"   // 12hr
      : "DD MMM, YYYY, HH:mm";    // 24hr

  return dayjs.utc(inputDate).tz(orgTimeZone).format(formatString);
}
export function convertDateFromUTC(inputDate) {
  if (!inputDate) return "";

  const localeInfo = ensureLocaleInfo();
  // let orgTimeZone;
  // if (localeInfo.timezone === "MACHINE") {
  //   orgTimeZone = dayjs.tz.guess(); // machine timezone
  // } else {
  //   orgTimeZone = timezoneMapping[localeInfo?.timezone] || "UTC";
  // }
  const orgTimeZone =
    timezoneMapping[localeInfo?.timezone] || "Asia/Kolkata";
  const timeFormat = localeInfo?.timeFormat || 24;
  const formatString =
    timeFormat === 1
      ? "DD MMM, YYYY"   // 12hr
      : "DD MMM, YYYY";    // 24hr

  return dayjs.utc(inputDate).tz(orgTimeZone).format(formatString);
}

export function combineByUserTimezone(
  rows = [],
  {
    dateKey = "date",
    sumKeys = ["accounts", "contacts","confirm","jobOpenings"],
  } = {}
) {
    const localeInfo = ensureLocaleInfo();
     const orgTimeZone =
    timezoneMapping[localeInfo?.timezone] || "Asia/Kolkata";
  if (!Array.isArray(rows) || rows.length === 0) return [];
 if (!Array.isArray(rows) || rows.length === 0) return [];

  const map = Object.create(null);

  for (const row of rows) {
    if (!row?.[dateKey]) continue;

    // Normalize UTC → Local date
    const localDate = dayjs
      .utc(row[dateKey])
      .tz(orgTimeZone)
      .format("YYYY-MM-DD");

    if (!map[localDate]) {
      map[localDate] = {
        date: localDate,
      };

      // Detect structure
      if (row.users) {
        map[localDate].users = {};
      } else {
        map[localDate].addedBy = row.addedBy ?? null;
        for (const key of sumKeys) {
          map[localDate][key] = 0;
        }
      }
    }

    // 🧩 Case 1: Multi-user rows
    if (row.users) {
      for (const userId of Object.keys(row.users)) {
        if (!map[localDate].users[userId]) {
          map[localDate].users[userId] = {};
          for (const key of sumKeys) {
            map[localDate].users[userId][key] = 0;
          }
        }

        for (const key of sumKeys) {
          const value = Number(row.users[userId]?.[key]);
          if (!Number.isNaN(value)) {
            map[localDate].users[userId][key] += value;
          }
        }
      }
    }
    // 🧩 Case 2: Single-user rows
    else {
      for (const key of sumKeys) {
        const value = Number(row[key]);
        if (!Number.isNaN(value)) {
          map[localDate][key] += value;
        }
      }
    }
  }

  return Object.values(map).sort(
    (a, b) => new Date(a.date) - new Date(b.date)
  );
}

export function extractDateAndTimeFromFormatted(dateTimeString) {
  if (!dateTimeString) {
    return { date: "", time: "" };
  }
  const parts = dateTimeString.split(",");
  if (parts.length < 3) {
    return { date: "", time: "" };
  }
  return {
    date: `${parts[0]},${parts[1]}`.trim(),
    time: parts[2].trim(),
  };
}